export const SLOT_TYPE = {
  GATEWAY: 'GATEWAY',
} as const;

export const FIELD_LABELS = {
  CONTEXTUAL: {
    NODE: 'booking-field-contextual-node',
    IMPRESSIONS: 'booking-field-impressions-booked-contextual',
    IMPRESSIONS_ALLOCATED: 'booking-field-impressions-allocated',
    IMPRESSIONS_WAITLISTED: 'booking-field-impressions-waitlisted',
    VALUE_BLOCKED: 'booking-field-value-blocked-contextual',
    SOV: 'booking-field-sov-contextual',
  },
  NON_CONTEXTUAL: {
    NODE: 'booking-field-non-contextual-node',
    IMPRESSIONS: 'booking-field-impressions-booked-non-contextual',
    IMPRESSIONS_ALLOCATED: 'booking-field-impressions-allocated',
    IMPRESSIONS_WAITLISTED: 'booking-field-impressions-waitlisted',
    VALUE_BLOCKED: 'booking-field-value-blocked-non-contextual',
    SOV: 'booking-field-sov-non-contextual',
  },
} as const;

export const SECTION_TITLES = {
  CONTEXTUAL: 'booking-field-contextual-nodes-title',
  NON_CONTEXTUAL: 'booking-field-non-contextual-nodes-title',
} as const;

export const SLOT_FIELDS = {
  SLOT_OR_PACKAGE_NAME: 'slotOrPackageName',
  CONTEXTUAL_NODE: 'contextualNode',
  IMPRESSIONS_BOOKED: 'impressionsBooked',
  IMPRESSIONS_ALLOCATED: 'impressionsAllocated',
  IMPRESSIONS_WAITLISTED: 'impressionsWaitlisted',
  VALUE_BLOCKED: 'valueBlockedAtPackageLevel',
  PERCENTAGE_BOOKED: 'percentageBooked',
} as const;

export const BOOKING_FIELD_KEYS = {
  ENTRY_ID: 'booking-field-entry-id',
  BRAND_NAME: 'booking-field-brand-name',
  ACCOUNT_EXEC_NAME: 'booking-field-account-exec-name',
  CATEGORY_NAME: 'booking-field-category-name',
  GP_SLOT: 'booking-field-gp-slot',
  TOTAL_IMPRESSIONS_BOOKED: 'booking-field-total-impressions-booked',
  TOTAL_VALUE_BLOCKED: 'booking-field-total-value-blocked',
  TOTAL_VALUE_BLOCKED_NON_CONTEXTUAL:
    'booking-field-total-value-blocked-non-contextual',
  TOTAL_IMPRESSIONS_BOOKED_NON_CONTEXTUAL:
    'booking-field-total-impressions-booked-non-contextual',
  ACCOUNT_MANAGER_NAME: 'table-header-am-name',
  GTM_STATUS: 'table-header-gtm-status',
  TYPE_OF_PURCHASE: 'table-header-type-of-purchase',
  SF_OPPORTUNITY_ID: 'table-header-sf-opportunity-id',
  COMMENTS_BY_POC: 'table-header-comments-by-poc',
} as const;
